var EventEmitterMixin = require("../../mixins/event-emitter.mixin");

var RecaptchaComponent = function () {
    var self = this;
    var $currentContext = $();
    var moduleOptions = {
        siteKey: ""
    };

    var classMap = {
        recaptcha: ".js-recaptcha__control"
    };

    var $recaptcha;
    var widgetId;

    this.getResponse = function() {
        return grecaptcha.getResponse(widgetId);
    }

    this.reset = function() {
        grecaptcha.reset(widgetId);
    }

    function create() {
        var id = $recaptcha.attr("id");

        widgetId = grecaptcha.render(id, {
            "sitekey": moduleOptions.siteKey,
            "theme": "light",
            "size": "normal",
            "callback": (gResponse) => self._raiseEvent("recaptcha-validated", gResponse)
            // "expired-callback": showError,
            // "error-callback": showError
        });
    }

    function initContext() {
        $recaptcha = $(classMap.recaptcha, $currentContext);
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);

        initContext();
        create();
    };
};

Object.assign(RecaptchaComponent.prototype, new EventEmitterMixin());

Object.defineProperty(RecaptchaComponent, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-recaptcha"
});

module.exports = RecaptchaComponent;
